import React, { useState } from 'react'
import BlockEditForm from './BlockEditForm'

export default function BlocksNewBlockPanel({
  changeRequestId,
  treatmentId,
  vocabulary,
  onRetryVocabulary = null,
  isBusy,
  onSubmit,
  onClose,
}) {
  const [table, setTable] = useState('numeric')
  const save = (after, onFieldErrors) =>
    onSubmit({ table, after, onFieldErrors })

  return (
    <aside
      className="lox-blocks-explorer__drawer box"
      data-testid="blocks-new-block"
    >
      <button
        type="button"
        className="delete is-pulled-right"
        aria-label="Close"
        onClick={onClose}
      />
      <h3 className="title is-6 mb-2">New block</h3>
      <div className="buttons has-addons mb-1">
        {['numeric', 'categorical'].map((option) => (
          <button
            key={option}
            type="button"
            className={`button is-small ${
              table === option ? 'is-selected is-info' : ''
            }`}
            onClick={() => setTable(option)}
            data-testid={`blocks-new-block-${option}`}
          >
            {option === 'numeric' ? 'Numeric' : 'Categorical'}
          </button>
        ))}
      </div>
      <BlockEditForm
        key={table}
        op="block.create"
        table={table}
        row={null}
        initialValues={{
          treatment_id: treatmentId,
          customer_type: 'ALL',
          conditions: [],
        }}
        vocabulary={vocabulary}
        onRetryVocabulary={onRetryVocabulary}
        draftKey={{
          changeRequestId,
          treatmentId,
          table,
          id: 'new',
          op: 'block.create',
        }}
        isBusy={isBusy}
        onSave={save}
        onCancel={onClose}
      />
    </aside>
  )
}
